<template>
  <div class="contact">
    <h2 class="--text-center">Kontakt</h2>
    <h3 class="--text-center">Ing. arch. Břetislav Krejsa</h3>
    <div class="contact__details">
      <img src="img/dum.png" alt="Test" class="contact_detail-image" />
      <p>Náměstí Míru 132<br />Domažlice<br />344 01</p>
      <img src="img/telefon.png" alt="Test" class="contact_detail-image" />
      <p>+420 728 934 856</p>
      <img src="img/dopis.png" alt="Test" class="contact_detail-image" />
      <p>kancelar@atelierkrejsa.cz</p>
      <img src="img/ico.png" alt="Test" class="contact_detail-image" />
      <p>03943453</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
<style>
.contact {
  grid-column: span 1;
}
.contact__details {
  gap: 0 24px;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.contact_detail-image {
  height: 120px;
  justify-self: right;
}

@media only screen and (max-width: 800px) {
  .contact {
    grid-column: span 2;
  }
}


@media only screen and (max-width: 400px) {
  .contact__details > p,
  .contact__details > img {
    grid-column: span 2;
    justify-self: center;
  }
}
</style>
